<template>
  <component
    :is="link ? 'a' : 'div'"
    :href="link && link.href"
    :target="link && link.target"
    :nofollow="link && link.nofollow"
    :class="['zg-logo-card', {
      [`zg-logo-card--background-${background}`]: background,
      'zg-logo-card--with-text': text,
      'zg-logo-card--small': small
    }]"
  >
    <zg-image
      v-bind="image"
      lazy-load
    />
    <span v-if="text">{{ text }} </span>
  </component>
</template>

<script>
  import ZgImage from '../ZgImage/ZgImage.vue'

  export default {
    name: 'ZgLogoCard',
    components: { ZgImage },
    props: {
      image: {
        type: Object,
        required: true,
        validator: ({ src }) => !!src
      },
      link: {
        type: Object,
        required: false,
        default: () => null,
        validator: (link) => !link || link.href
      },
      text: {
        type: String,
        required: false,
        default: null
      },
      background: {
        type: String,
        required: false,
        default: 'white',
        validator: value => [
          'white',
          'beige'
        ].includes(value)
      },
      small: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-logo-card {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: rem(80px);
    padding: rem(24px);
    border-radius: rem(24px);
    border: none;

    @include mq(medium) {
      height: rem(104px);
      padding: rem(32px);
      border-radius: rem(32px);
    }

    ::v-deep img {
      width: auto;
      height: auto;
      max-width: 60%;
      max-height: 100%;

      @include mq(medium) {
        max-width: 60%;
      }
    }

    // ? ----------------------------------------------------------------------
    // with text
    // ? ----------------------------------------------------------------------

    &--with-text {
      color: color(black);
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-around;

      @include mq(medium) {
        justify-content: space-between;
      }

      ::v-deep img {
        max-width: rem(100px);

        @include mq(medium) {
          max-width: 50%;
        }
      }
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-logo-card--background-white {
    background-color: color(white);
  }

  .zg-logo-card--background-beige {
    background-color: color(beige);
  }

  // ? ----------------------------------------------------------------------
  // small
  // ? ----------------------------------------------------------------------

  .zg-logo-card--small {
    padding: rem(16px);

    @include mq(medium) {
      height: rem(80px);
      padding: rem(24px);
      border-radius: rem(24px);
    }

    ::v-deep img {
      max-width: 80%;

      @include mq(medium) {
        max-width: 60%;
      }
    }
  }
</style>
